module.exports = __webpack_public_path__ + "fonts/bilbo-swash-caps-regular.ttf";